namespace $.$$ {

	$mol_style_define( $shm_hitalama_taskmanager_card, {
		display: 'flex',
		flex: {
			direction: 'column',
		},
		padding: {
			// top: $mol_gap.block,
			// bottom: $mol_gap.block,
		},
		gap: 0,
		background: {
			color: $mol_theme.card,
		},
		border: {
			radius: '8px',
		},
		// boxShadow: '0 0 0 1px var(--mol_theme_line)',
		minWidth: 0,
		minHeight: '80px',

		Header: {
			justifyContent: 'flex-end',
			padding: {
				top: '4px',
				right: '8px',
			},
		},

		Date: {
			color: $mol_theme.shade,
			font: {
				size: '.75rem',
			},
			lineHeight: '1rem',
		},

		Body: {
			display: 'grid',
			gridTemplateColumns: 'auto minmax(0, 1fr) auto',
			alignItems: 'start',
			gap: 0,
			minWidth: 0,
			flex: {
				grow: 1,
				shrink: 1,
			},
		},

		Priority: {
			justifyContent: 'center',
			flex: {
				shrink: 0,
			},
		},

		Left: {
			alignItems: 'center',
			flex: {
				direction: 'column',
				shrink: 0,
			},
		},

		Title: {
			width: '100%',
			minHeight: '100%',
			// maxHeight: '10rem',
			background: {
				color: 'transparent',
			},
			font: {
				family: 'system-ui, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
			},
			flex: {
				grow: 1,
				shrink: 1,
			},
			Edit: {
				minHeight: '100%',
				boxShadow: 'none',
				border: {
					width: 0,
				},
				background: {
					color: 'transparent',
				},
				font: {
					family: 'system-ui, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
				},
			},
			View: {
				minHeight: '100%',
				boxShadow: 'none',
				border: {
					width: 0,
				},
				background: {
					color: 'transparent',
				},
				font: {
					family: 'system-ui, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
				},
			},
		},

		Right: {
			alignItems: 'center',
			justifyContent: 'flex-end',
			flex: {
				direction: 'column',
				shrink: 0,
			},
		},

		Move_left: {
			opacity: 0,
			pointerEvents: 'none',
		},

		Move_right: {
			opacity: 0,
			pointerEvents: 'none',
		},

		Delete: {
			opacity: 0,
			pointerEvents: 'none',
			Bubble: {
				zIndex: 10,
			},
		},

		Delete_confirm: {
			whiteSpace: 'nowrap',
		},

		'@': {
			shm_hitalama_taskmanager_card_hovered: {
				true: {
					Move_left: {
						opacity: 1,
						pointerEvents: 'auto',
					},
					Move_right: {
						opacity: 1,
						pointerEvents: 'auto',
					},
					Delete: {
						opacity: 1,
						pointerEvents: 'auto',
					},
				},
			},
		},
	} )

}
